import React, { Component } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';

import { inChildren } from 'services/utils';

import { BackBtn, DeleteBtn, EditBtn } from 'components/buttons/Btn';
// import Toolbar from 'components/Toolbar';
import FooterBar from 'components/FooterBar';
import NotFoundItems from 'components/NotFoundItems';
import Progress from 'components/Progress';
import Rbac, { useCan } from 'components/Rbac';
import Screen from 'components/Screen';
import Tabs, { Tab } from 'components/Tabs';
import { show as showModalConfirm } from 'modals/Confirm';

import * as actions from './actions';
import ShowExecutorInfo from './ShowExecutorInfo';
import ShowExecutorsAvailable from './ShowExecutorsAvailable';
import ShowExecutorsMileage from './ShowExecutorsMileage';
import ShowExecutorsSchedule from './ShowExecutorsSchedule';
import ShowExecutorsUsers from './ShowExecutorsUsers';

class Container extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notFound: false
    };
  }

  componentDidMount() {
    this.handleGetOne();
  }

  handleGetOne = async () => {
    const { match: { params: { id } = {} } = {}, executorsActions } =
      this.props;
    try {
      await executorsActions.getOne(id);
    } catch (err) {
      this.setState({ notFound: true });
    }
  };

  handleDelete = async () => {
    const {
      executorsActions,
      record = {},
      dispatch,
      history = {}
    } = this.props;

    const res = await dispatch(
      showModalConfirm({
        title: 'Удаление',
        content: 'Удалить дезинфектора?'
      })
    );

    if (res) {
      try {
        await executorsActions.deleteOne(record.id);
        history.goBack();
      } catch (err) {
        console.error(err);
      }
    }
  };

  render() {
    const { children, ...rest } = this.props;
    return inChildren(children, {
      ...rest,
      notFound: this.state.notFound,
      handleUpdate: this.handleUpdate,
      handleDelete: this.handleDelete
    });
  }
}

const mapStateToProps = (state, ownProps) => {
  const { resourceName = '' } = ownProps;
  const target = state[resourceName] || {};
  const { one = {} } = target;
  return {
    record: one.data,
    loading: one.loading
  };
};

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  executorsActions: bindActionCreators(actions, dispatch)
});

const ContainerConnect = connect(
  mapStateToProps,
  mapDispatchToProps
)(Container);

const View = (props) => {
  const {
    handleDelete,
    record = {},
    loading,
    match = {},
    basePath = '/',
    notFound
  } = props;

  const [tab, setTab] = React.useState();
  const itemReceived = !!(record && record.id);
  const history = useHistory();
  const back = history.goBack;
  let title = '';
  if (itemReceived) {
    title = `Дезинфектор: ${record.name}`;
  }

  const is_writable = useCan('executors:write');

  return (
    <Screen title={title}>
      {loading && <Progress />}
      {notFound && <NotFoundItems message="Дизинфектор не найден" />}
      {itemReceived && (
        <Tabs value={tab} onChange={(path) => setTab(path)}>
          <Tab label="Инфо" eventKey={match.url}>
            <Box p={2}>
              <ShowExecutorInfo {...props} />
            </Box>
          </Tab>
          <Tab label="Пользователи" eventKey={`${match.url}/users`}>
            <Rbac operation="executor_users:read">
              <ShowExecutorsUsers executor_id={record.id} />
            </Rbac>
          </Tab>
          <Tab label="Отсутствие" eventKey={`${match.url}/available`}>
            <Rbac operation="available:read">
              <ShowExecutorsAvailable executor_id={record.id} />
            </Rbac>
          </Tab>
          <Tab label="Расписание" eventKey={`${match.url}/schedule`}>
            <Rbac operation="schedule:read">
              <ShowExecutorsSchedule executor_id={record.id} />
            </Rbac>
          </Tab>
          <Tab label="Автопробег" eventKey={`${match.url}/mileage`}>
            <Rbac operation="mileage:read">
              <ShowExecutorsMileage executor_id={record.id} />
            </Rbac>
          </Tab>
        </Tabs>
      )}
      <FooterBar>
        <Grid item>
          <Grid container spacing={1}>
            <Grid item>
              <BackBtn onClick={back}>Назад</BackBtn>
            </Grid>
            <Grid item>
              {itemReceived && is_writable && (
                <EditBtn
                  to={{
                    pathname: `${basePath}/edit/${record.id}`,
                    state: { from: `${basePath}/show/${record.id}` }
                  }}>
                  Редактировать
                </EditBtn>
              )}
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          {itemReceived && is_writable && (
            <DeleteBtn onClick={handleDelete}>Удалить</DeleteBtn>
          )}
        </Grid>
      </FooterBar>
    </Screen>
  );
};

const ExecutorsShow = (props) => (
  <ContainerConnect {...props}>
    <View />
  </ContainerConnect>
);

export default ExecutorsShow;
